import { createConfig, http } from "wagmi";
import { injected } from "wagmi/connectors";
import { defineChain } from "viem";
/**
 * Web3Module 설정 파일
 * wagmi와 RainbowKit의 설정을 정의합니다.
 */

// 지원할 체인 목록
// EQ Hub Chain
// const CHAIN = defineChain({
//   id: 5347,
//   name: "EQHub Network",
//   nativeCurrency: { name: "EQHub", symbol: "EQHub", decimals: 18 },
//   rpcUrls: {
//     default: {
//       http: [
//         "http://43.200.220.233:11832?socketKey=LLAbHJ2FfoVxCXdRoo3g6E1o_0dLM9hCQaS729jag5M",
//       ],
//     },
//   },
//   blockExplorers: {
//     default: {
//       name: "EQHub Explorer",
//       url: "https://field.feature.eqhub.eqbr.com/5347",
//     },
//   },
//   testnet: false,
// });

// Sepolia
// const CHAIN = defineChain({
//   id: 11155111,
//   name: "Sepolia",
//   nativeCurrency: { name: "SepoliaETH", symbol: "ETH", decimals: 18 },
//   rpcUrls: {
//     default: {
//       http: ["https://sepolia.infura.io/v3/3ce750efb8b445c9ac53680deba1d43d"],
//     },
//   },
//   blockExplorers: {
//     default: {
//       name: "Spolia Etherscan",
//       url: "https://sepolia.etherscan.io/",
//     },
//   },
//   testnet: false,
// });

// Ethereum
const CHAIN = defineChain({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://socket-ag.eqhub.eqbr.com?socketKey=4ZEU1bl4qdJCyyDBLlBsfCTVWPRUW28RMEYvhIpP8Qg",
      ],
    },
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io/",
    },
  },
  testnet: false,
});

// 체인 설정
export const chains = [CHAIN];

// 지원할 지갑 커넥터 목록
export const connectors = createConfig({
  chains: [CHAIN],
  connectors: [injected()],
  transports: {
    [CHAIN.id]: http(),
  },
  ssr: true, // SSR 설정 추가
});

// wagmi 설정
export const wagmiConfig = connectors;

// 기본 설정 내보내기
export default {
  chains,
  connectors,
  wagmiConfig,
};
